module.exports = __webpack_public_path__ + "static/media/Start Screeen-09.e76c9933.webp";